module.exports = "<div class=\"row no-gutters\">\n  <div class=\"col-2\">\n    <button (click)=\"removeFromCart()\" class=\"btn btn-block btn-secondary\">-</button>\n  </div>\n  <div class=\"col text-center\">\n    {{shoppingCart.getQuantity(product)}} in cart\n  </div>\n  <div class=\"col-2\">\n    <button (click)=\"addToCart()\" class=\"btn btn-block btn-secondary\">+</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/products/product-quantity/product-quantity.component.html
// module id = ../../../../../src/app/products/product-quantity/product-quantity.component.html
// module chunks = main